"use client";

import React from "react";
import { Instagram, Linkedin, Twitter, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const titleMap: Record<string, string> = {
    "Home": "/HomePage",
    "About Us": "/AboutUsPage",
    "Products": "/Products",
    "Markets": "https://trusting-sunbird.10web.cloud/markets/",
    "Contact": "/ContactPage"
  };
  if (loading) {
    return <div className="flex flex-wrap gap-6 justify-center md:justify-start">
        {[1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className="h-4 w-20 bg-muted animate-pulse rounded-lg" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full">
      <NavigationMenuList className="flex-wrap justify-center md:justify-start gap-x-8 gap-y-4">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="bg-transparent hover:bg-transparent focus:bg-transparent p-0 h-auto">
              <Link to={titleMap[item.title] || item.url || "#"} className="text-xs sm:text-sm font-medium text-muted-foreground hover:text-primary transition-colors uppercase tracking-wider">
                {item.title}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [];
  return <footer data-section-id="252323" id="footer" className="bg-[#fcfaf8] text-foreground border-t border-border/40">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-8">
          <div className="flex flex-col items-center md:items-start gap-6">
            <Link to="/">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>
        
        <div className="pt-8 border-t border-border/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-xs text-muted-foreground text-center md:text-left">
            © 2026 Oriental World Corporation Limited. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <Link to="https://trusting-sunbird.10web.cloud/privacy-policy/" newTab className="text-xs text-muted-foreground hover:text-primary transition-colors underline underline-offset-4">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}